import React, { useState, useEffect } from "react";
import { FaIdCard } from "react-icons/fa";
import { MdHourglassEmpty, MdFormatListBulleted } from "react-icons/md";
import { FaSignInAlt } from "react-icons/fa";
import InsuranceService from "../../../services/InsuranceService";
import SideBar from "../../../components/Sidebar";
import LoadingScreen from "../../../components/LoadingScreen/LoadingScreen";
import Swal from "sweetalert2";
import SubscriptionDialog from "../../../components/Dialogs/SubscriptionDialog";
import { useSubscriptionCheck } from "../../../hooks/useSubscriptionCheck";

const InsurancePosp = () => {
  const [loading, setLoading] = useState(false);

  const { premiumStatus, showDialog, setShowDialog, checkSubscriptionStatus } =
    useSubscriptionCheck();

  useEffect(() => {
    const initialize = async () => {
      setLoading(true);
      try {
        await checkSubscriptionStatus();
      } finally {
        setLoading(false);
      }
    };
    initialize();
  }, []);

  /* -------------------------------
      POSP Registration Handler
  -------------------------------- */
  const handlePospRegistration = async () => {
    if (loading) return;

    setLoading(true);
    try {
      const result = await InsuranceService.pospRegistration();

      if (!result.success) {
        Swal.fire("Oops!", result.message || "Request failed!", "error");
        return;
      }

      const res = result.data;

      if (res.status === "SUCCESS") {
        Swal.fire("Success!", res.message, "success");
      } else {
        Swal.fire("Oops!", res.message || "Something went wrong", "error");
      }
    } catch (error) {
      Swal.fire(
        "Oops!",
        error.response?.data?.message || error.message || "Network error",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  /* -------------------------------
      POSP Login Handler
  -------------------------------- */
  const handlePospLogin = async () => {
    if (loading) return;

    setLoading(true);
    try {
      const result = await InsuranceService.pospLogin();

      if (!result.success) {
        Swal.fire("Oops!", result.message || "Request failed!", "error");
        return;
      }

      const res = result.data;

      if (res.status === "SUCCESS") {
        const url = res.data?.url;
        window.open(url, "_blank");
      } else {
        Swal.fire("Oops!", res.message || "Something went wrong", "error");
      }
    } catch (error) {
      Swal.fire(
        "Oops!",
        error.response?.data?.message || error.message || "Network error",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  /* -------------------------------
      Card List
  -------------------------------- */
  const services = [
    {
      name: "POSP Registration",
      icon: <FaIdCard size={40} color="#0d6efd" />,
      action: handlePospRegistration,
    },
    {
      name: "POSP Login",
      icon: <FaSignInAlt size={40} color="#0d6efd" />,
      action: handlePospLogin,
    },
    {
      name: "Policy Report",
      icon: <MdFormatListBulleted size={40} color="#0d6efd" />,
      action: () => (window.location.href = "/insurance-posp/history"),
    },
  ];

  return (
    <div>
      {loading && <LoadingScreen />}

      <div className="container-fluid mt-3">
        <div className="row">
          <SideBar />

          <div className="col-md-9 mb-3">
            <div className="card mb-4 shadow-sm">
              <div className="card-body">
                <h5 className="card-title mb-4">Insurance POSP</h5>

                <div className="row justify-content-center">
                  <div className="d-flex gap-4 flex-wrap justify-content-center">
                    {services.map((service, index) => (
                      <div
                        key={index}
                        className="border rounded p-4 text-center shadow-sm hover-effect"
                        style={{
                          width: "220px",
                          cursor: loading ? "not-allowed" : "pointer",
                          opacity: loading ? 0.6 : 1,
                          transition: "all 0.3s ease",
                        }}
                        onClick={() => {
                          // FIX: Check if premiumStatus is exactly 'true'
                          if (premiumStatus === "true") {
                            !loading && service.action();
                          } else {
                            setShowDialog(true);
                          }
                        }}
                        onMouseEnter={(e) =>
                          !loading &&
                          (e.currentTarget.style.transform = "scale(1.05)")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.transform = "scale(1)")
                        }
                      >
                        <div className="mb-3">{service.icon}</div>
                        <div
                          className="fw-medium"
                          style={{ fontSize: "16px", fontWeight: "500" }}
                        >
                          {service.name}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <SubscriptionDialog
        show={showDialog}
        onHide={() => setShowDialog(false)}
        serviceName="Insurance POSP"
      />
    </div>
  );
};

export default InsurancePosp;
